'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { MENU_TREE_LOAD, MENU_NODE_REPLACE, MENU_TREE_ADD_NODE, MENU_TREE_ADD_CHILD, MENU_TREE_ADD_NODE_TO_BOTTOM, MENU_TREE_CLONE_NODE, MENU_TREE_DELETE_NODE, MENU_TREE_DELETE_TREE, MENU_NODE_UPDATE, MENU_NODE_UPDATE_PAGE_LINK_ID } from 'simple-menus-core/actions/ActionTypes';
import MenuNode from 'simple-menus-core/models/MenuNode';
import MenuNodeTypes from 'simple-menus-core/enums/MenuNodeTypes';
import { byName } from 'ContentUtils/constants/TemplateTypes';
export default function MenuNodes(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case MENU_TREE_LOAD:
      {
        const {
          nodesById
        } = action;
        if (!nodesById) return state;
        return state.merge(SeamlessImmutable(nodesById));
      }
    case MENU_TREE_ADD_CHILD:
    case MENU_TREE_ADD_NODE_TO_BOTTOM:
    case MENU_TREE_ADD_NODE:
      {
        const {
          nodeId,
          menuNode
        } = action;
        if (!(nodeId && menuNode)) return state;
        return state.set(nodeId, menuNode);
      }
    case MENU_TREE_CLONE_NODE:
      {
        const {
          nodesById
        } = action;
        if (!nodesById) return state;
        return state.merge(nodesById);
      }
    case MENU_NODE_UPDATE:
      {
        const {
          updates,
          id
        } = action;
        if (!(updates && id)) return state;
        const node = state[id];
        if (!node) return state;
        return state.set(id, node.merge(updates));
      }
    case MENU_NODE_UPDATE_PAGE_LINK_ID:
      {
        const {
          page,
          id
        } = action;
        if (!(page && id)) return state;
        const node = state[id];
        if (!node) return state;
        let newNodeProps = {
          pageLinkId: page.id,
          contentGroupId: null,
          pageLinkName: page.name,
          state: page.state || null,
          categoryId: page.categoryId,
          isPublished: MenuNode.getIsPublished(page),
          contentType: page.contentType,
          isDeleted: MenuNode.getIsDeleted(page),
          subCategory: page.subCategory
        };
        if (page.categoryId === byName.blog.categoryId && !page.subCategory) {
          newNodeProps = Object.assign({}, newNodeProps, {
            contentGroupId: page.id,
            pageLinkId: null,
            subCategory: null
          });
        }
        return state.set(id, node.merge(newNodeProps));
      }
    case MENU_NODE_REPLACE:
      {
        const {
          id,
          nodeType
        } = action;
        const node = state[id];
        if (!node) return state;
        const defaultNode = new MenuNode({
          linkLabel: node.linkLabel,
          type: nodeType
        });
        switch (nodeType) {
          case MenuNodeTypes.NO_LINK:
          case MenuNodeTypes.URL_LINK:
            {
              return state.set(id, defaultNode);
            }
          case MenuNodeTypes.PAGE_LINK:
            {
              if (node.type === MenuNodeTypes.PAGE_LINK_WITH_PARAMS) {
                return state.set(id, node.merge({
                  type: nodeType,
                  linkParams: null
                }));
              }
              return state.set(id, defaultNode);
            }
          case MenuNodeTypes.PAGE_LINK_WITH_PARAMS:
            {
              if (node.type === MenuNodeTypes.PAGE_LINK) {
                return state.set(id, node.merge({
                  type: nodeType
                }));
              }
              return state.set(id, defaultNode);
            }
          default:
            {
              return state;
            }
        }
      }
    case MENU_TREE_DELETE_NODE:
      {
        const {
          id,
          childIds
        } = action;
        if (!id) return state;
        const idsToDelete = [id, ...childIds];
        return state.without(idsToDelete);
      }
    case MENU_TREE_DELETE_TREE:
      {
        const {
          nodeIds
        } = action;
        if (!nodeIds) return state;
        return state.without(nodeIds);
      }
    default:
      {
        return state;
      }
  }
}